import { render, staticRenderFns } from "./fieldsChoose.vue?vue&type=template&id=021d9aa9"
import script from "./fieldsChoose.vue?vue&type=script&lang=js"
export * from "./fieldsChoose.vue?vue&type=script&lang=js"
import style0 from "./fieldsChoose.vue?vue&type=style&index=0&id=021d9aa9&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021d9aa9')) {
      api.createRecord('021d9aa9', component.options)
    } else {
      api.reload('021d9aa9', component.options)
    }
    module.hot.accept("./fieldsChoose.vue?vue&type=template&id=021d9aa9", function () {
      api.rerender('021d9aa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportForm/exportManage/fieldsChoose.vue"
export default component.exports